var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_10500)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 274.031C248.009 273.454 210.373 280.72 199.763 314.396C192.677 336.885 170.354 351.301 92.5065 348.994H-11.8662",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 274.031C282.991 273.454 320.627 280.72 331.237 314.396C338.323 336.885 360.646 351.301 438.493 348.994H542.866",
    stroke: "black",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.361 349.007C167.278 347.277 193.189 337.244 201.492 310.949C204.76 298.262 221.906 273.121 264.347 274.043C283.568 273.274 324.318 282.462 333.544 325.365C335.411 334.046 348.101 347.451 370.364 349.007H379.099C376.041 349.211 373.129 349.2 370.364 349.007H155.361Z",
    fill: "url(#paint0_linear_226_10500)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.713,
    cy: 301.546,
    rx: 19.484,
    ry: 13.9266,
    transform: "rotate(16.4835 292.713 301.546)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.564 178L265.564 226.252",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.747 214.731L311.089 247.389",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 214.733L218.658 247.39",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 390C67 398.284 60.5081 405 52.5 405C44.4919 405 38 398.284 38 390C38 381.716 44.4919 375 52.5 375C60.5081 375 67 381.716 67 390Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 398C160 404.627 154.851 410 148.5 410C142.149 410 137 404.627 137 398C137 391.373 142.149 386 148.5 386C154.851 386 160 391.373 160 398Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 386C464 394.284 457.508 401 449.5 401C441.492 401 435 394.284 435 386C435 377.716 441.492 371 449.5 371C457.508 371 464 377.716 464 386Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 413C329 421.284 322.508 428 314.5 428C306.492 428 300 421.284 300 413C300 404.716 306.492 398 314.5 398C322.508 398 329 404.716 329 413Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 441C444 446.523 439.747 451 434.5 451C429.253 451 425 446.523 425 441C425 435.477 429.253 431 434.5 431C439.747 431 444 435.477 444 441Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 441C109 446.523 104.747 451 99.5 451C94.2533 451 90 446.523 90 441C90 435.477 94.2533 431 99.5 431C104.747 431 109 435.477 109 441Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_10500",
    x1: 265.788,
    y1: 274,
    x2: 265.788,
    y2: 349.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#282828",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_10500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_여드름.6bcf207a8b3f1e8134b25a45affd55a5.svg";
export { ForwardRef as ReactComponent };